function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import styled, { css } from 'styled-components';
import cl from 'classnames';
import truncateFunc from '@dolstaff/libs/utils/truncate';
import stripHtml from '@dolstaff/libs/utils/stripHtml';
import getLineHeightByFontSize from './getLineHeightByFontSize';
const getFontWeight = fontWeight => {
  let weight = 'normal';
  switch (fontWeight) {
    case 'regular':
      weight = 'normal';
      break;
    case 'semi-bold':
      weight = '600';
      break;
    case 'bold':
      weight = 'bold';
      break;
    case 'extra-bold':
      weight = '800';
      break;
    default:
      break;
  }
  return weight;
};
const Main = styled.div.withConfig({
  displayName: "Typo__Main",
  componentId: "qbx7is-0"
})(["font-size:", ";line-height:", ";font-weight:", ";margin-bottom:", ";", ";p{font-size:inherit;line-height:inherit;margin-top:0.5em;margin-bottom:0.5em;&:first-child{margin-top:0;}}&.overflow{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;}"], _ref2 => {
  let {
    fontSize
  } = _ref2;
  return `${fontSize}px`;
}, _ref3 => {
  let {
    fontSize
  } = _ref3;
  return getLineHeightByFontSize(fontSize);
}, _ref4 => {
  let {
    fontWeight
  } = _ref4;
  return getFontWeight(fontWeight);
}, _ref5 => {
  let {
    marginBottom = '0.5em'
  } = _ref5;
  return marginBottom;
}, _ref6 => {
  let {
    upperCase
  } = _ref6;
  return upperCase ? css(["text-transform:uppercase;"]) : '';
});
const Typo = _ref => {
  let {
      fontSize = 16,
      fontWeight = 'regular',
      upperCase = false,
      htmlContent = '',
      truncate = 0,
      maxLine = -1,
      className,
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, ["fontSize", "fontWeight", "upperCase", "htmlContent", "truncate", "maxLine", "className", "children", "style"]);
  let truncatedContent = '';
  let myStyle = {};
  const lineHeight = getLineHeightByFontSize(fontSize, true);
  if (maxLine > 0) {
    truncatedContent = stripHtml(htmlContent);
    myStyle = {
      maxHeight: `${lineHeight * maxLine}px`
    };
  }
  if (truncate > 0) {
    truncatedContent = truncateFunc(stripHtml(htmlContent), truncate);
  }
  const html = {
    dangerouslySetInnerHTML: {
      __html: truncatedContent || htmlContent
    }
  };
  return React.createElement(Main, _extends({}, props, htmlContent ? html : {}, {
    style: _objectSpread({
      myStyle
    }, style),
    fontSize: fontSize,
    fontWeight: fontWeight,
    upperCase: upperCase,
    className: cl(className, {
      overflow: maxLine > -1
    })
  }), children);
};
export default Typo;